import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import storageNutritionAllergenBG from '../media/newstoragebackground.jpg';
//import storageNutritionAllergenBG from '../media/holidaybigBG2.jpg';
import paper1 from '../media/unlinedpaper.jpg';
import paper2 from '../media/unlinedpaper.jpg'
import paper3 from '../media/unlinedpaper.jpg'

const TourVideoSection = (props) => {

	return (
	  <FluidContainer fluid>
	    <InternalContainer>
		  <h1>Our Sugar House Tour!</h1>
		  <VideoContainer className="videoContainer">
			  <iframe width="1280" height="720" src="https://www.youtube.com/embed/t39Y3XQ4RBU" 
			  		  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
			  </iframe>
		  </VideoContainer>

	    </InternalContainer>
	  </FluidContainer>
	); 
};

const VideoContainer = styled.div`
	position: relative;
	padding-bottom: 65.25%;
	padding-top: 25px;
	height: 0;

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
`;

const PaperImgsRow = styled(Row)`
	h3 { padding: 0px 0 24px 0; margin: 0; }
	h4 { font-weight: bold!important; }
`;

const PaperImgCol1 = styled(Col)`
	margin: 0 0 20px 0;
	${media.xl` margin: 0; `}

	div {  background-image: url(${paper1});  padding: 20px 12px 20px 12px; }
`;
const PaperImgCol2 = styled(Col)`
	margin: 0 0 20px 0;
	${media.xl` margin: 0; `}

	div {  background-image: url(${paper2});  padding: 20px 12px 20px 12px; }
`;
const PaperImgCol3 = styled(Col)`
	margin: 0 0 20px 0;
	${media.xl` margin: 0; `}

	div {  background-image: url(${paper3});  padding: 20px 12px 20px 12px; }
`;

const PaperImg = styled.img`
	height: auto;
	width: 100%;
	position: absolute;

`;

const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${storageNutritionAllergenBG}); 
	
	/*
    background-size: 100%; /* size the background image at 100% like any responsive img tag */
    background-position: top center;
    background-repeat:no-repeat;
    */
`;

const InternalContainer = styled(Container)`
	text-align: center;
	h1 { 
		margin: 0 0 20px 0;
		/*color: white;*/
	}
`;

const ButtonStyled = styled(Button)`
  cursor: pointer;
  display: block;
  border: 0px!important;
  color: white!important;
  font-weight: bold!important;
  background-color: #800000!important;
  width: 250px;
  ${media.sm` width: 290px; `}
  
  height: 40px;
  line-height: 20px!important;
  transition: all 0.5s;
  margin: 15px 0 0 0;

  p {
    cursor: pointer;
    display: inline;
    position: relative;
    transition: 0.5s;
  }

  p:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    right: -20px;
    transition: 0s;
  }

  :hover p { padding-right: 25px; }
  :hover p:after { opacity: 1; right: 0; }
  :active p:after { opacity: 0; }
  :active { box-shadow: 0 5px #666; transform: translateY(6px); }
`;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/

export default TourVideoSection;


// WEBPACK FOOTER //
// ./src/components/TourVideoSection.js